export default "__VITE_ASSET__BUgR9P6A__"